if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector("form")
        this.form.querySelector("[name=id]").disabled = false
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
        this.submitButton = this.querySelector('[type="submit"]')

        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog")

        this.hideErrors = this.dataset.hideErrors === "true"
        document.addEventListener("activeVariantUpdated", this.handleActiveProductVariant.bind(this))
      }
      handleActiveProductVariant(event) {
        const { activeVariant, activeProduct } = event.detail
        this.form.querySelector("[name=id]").value = activeVariant.id
        this.form.querySelector("[name=product-id]").value = activeProduct.id
      }

      connectedCallback() {
        subscribe(PUB_SUB_EVENTS.cartError, async (event) => {
          this.handleErrorMessage(event.message);
     
          this.submitButton.classList.remove("loading")
          this.submitButton.querySelector("span").classList.remove("hidden")
          this.submitButton.removeAttribute("aria-disabled")
          this.querySelector(".gz-loader").classList.add("hidden")
        });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute("aria-disabled") === "true") return

        this.handleErrorMessage();
        this.setLoading(true);

        const config = fetchConfig("javascript")
        config.headers["X-Requested-With"] = "XMLHttpRequest"
        delete config.headers["Content-Type"]

        let properties = {};
        const formData = new FormData(this.form);
        const productId = parseInt(formData.get("id"));
        const upgradedDDEle = document.querySelector('input[name="__gzdd"]'); 
        const upgradedDDStorage = document.querySelector('input[name="__gzddst"]');

        if (upgradedDDEle && upgradedDDEle.value) {
          formData.append('properties[__gzdd]', upgradedDDEle.value);
          properties["__gzdd"] = upgradedDDEle.value;
        }

        if (upgradedDDStorage && upgradedDDStorage.value) {
          formData.append('properties[__gzst]', upgradedDDStorage.value);
          properties["__gzst"] = upgradedDDStorage.value;
        }
        config.body = formData

        const warrantyId = window.GzTheme?.GZ_WARRANTY;

        try {
          // Warranty is selected, add product and warranty
          if (warrantyId) {
            await window.GzTheme.addProductAndWarranty(productId, warrantyId, properties);
          
          // NO warranty selected, add product only
          } else {
            const add = {
              items: [
                {
                  id: productId,
                  quantity: 1,
                  properties: properties
                }
              ]
            };

            await window.GzTheme.addToCart(add);
          }
          
        } catch (error) {
          this.handleErrorMessage(error);
        } finally {
          this.setLoading(false);
          window.location = window.routes.cart_url;
        }
      }

      setLoading(isLoading) {
        const loader = this.querySelector(".gz-loader");
        const btn = this.submitButton;
        const btnText = btn?.querySelector("span");
      
        if (isLoading) {
          btn?.setAttribute("aria-disabled", "true");
          btn?.classList.add("loading");
          btnText?.classList.add("hidden");
          loader?.classList.remove("hidden");
        } else {
          btn?.removeAttribute("aria-disabled");
          btn?.classList.remove("loading");
          btnText?.classList.remove("hidden");
          loader?.classList.add("hidden");
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        const soldOutMessage = this.submitButton.querySelector(".sold-out-message")
        this.submitButton.setAttribute("aria-disabled", true)
        this.submitButton.querySelector("span").classList.add("hidden")
        soldOutMessage?.classList.remove("hidden")
        this.error = true

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }
    },
  )
}